export const removeDays = (dateObj: Date, numDays: number) => {
	const newDate = dateObj.setDate(dateObj.getDate() - numDays)
	return new Date(newDate)
}
